export default {
    infoData: {
        companyName: '',
        siteName: '',
        ledgerName: '',
        businessType: '',
        feeTaskType: '',
        noTaxAmount: '',
        amount: '',
        remark: '',
        taxAmount: '',
        supplierComfirmAmount: ''
    },
    tableDataItems: [
        // {
        //     prop: 'orderCode',
        //     label: '单号',
        //     type: 'normal'
        // },
        {
            prop: 'feeName',
            label: '费用名称',
            type: 'normal'
        },
        {
            prop: 'amount',
            label: '总费用',
            type: 'normal'
        },
        {
            prop: 'supplierAmount',
            label: '确认费用金额',
            type: 'normal'
        },
        {
            prop: 'supplierMsg',
            label: '备注',
            type: 'normal'
        },
        {
            prop: 'replyMsg',
            label: '安得回复',
            type: 'normal'
        }
    ],
    costTableDataItems: [
        {
            prop: 'businessOrderNo',
            label: '业务单号',
            type: 'normal',
            width: '180'
        },
        {
            prop: 'feeHeaderName',
            label: '费用名称',
            width: '150',
            type: 'normal'
        },
        {
            prop: 'feeType',
            label: '费用类型',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'businessMainClass',
            label: '业务大类',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'supName',
            label: '供应商名称',
            width: '250',
            type: 'normal'
        },
        {
            prop: 'contractNo',
            label: '供应商合同',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'currencyCode',
            label: '币种',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'taxrate',
            label: '税率',
            width: '80',
            type: 'normal'
        },
        {
            prop: 'exchangeRateType',
            label: '成本汇率',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'initialAmt',
            label: '总金额',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'initialFee',
            label: '不含税总金额',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'initialTax',
            label: '税金',
            width: '100',
            type: 'normal'
        },
        {
            prop: 'remark',
            label: '备注',
            width: '200',
            type: 'normal'
        },
        {
            prop: 'estimateReason',
            label: '调整原因',
            width: '150',
            type: 'normal'
        }
    ]
};
